import {Box, IconButton, Menu, styled, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {AIUseIcon} from "../../assets/AIUseIcon";
import AIMenu from "./AIMenu";
import {initDiagramTradingBlock1} from "./initDiagramTradingBlock1";

export const TradingBlockContainer = styled(Box)({
    position: "relative",
    minHeight: "100px",
    padding: "10px 5px",
    overflow: "hidden",
    gap: "10px",
    borderRadius: "8px",
    border: "1px solid #808080",
});

export const TradingBlockTitle = styled(Box)({
    color: "#FFFFFF",
    "& p":{
        margin: "3px 0",
        color: "#D3D3D3",
        fontSize: "12px",
    }
});

export const TradingBlockTextContainer = styled(Box)({
    position: "absolute",
    zIndex: 2,
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    top: 0,
    backdropFilter: "blur(3px)",
    padding: "0 10px",
    boxSizing: "border-box",
});

export const TradingBlockDiagram = styled(Box)({
    minHeight: "100%",
    left: 0,
    top: 0,
    position: "absolute",
    width: "100%",
});

export const TradingBlockTopButtons = styled(Box)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "end",
    zIndex: 2,
});

export const TradingBlockTopButtonsContainer = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr",
});

export const TradingBlockTopButtonEl = styled(IconButton)({
    backdropFilter: "blur(3px)",
    transition: "transform .3s ease",
    "&:hover":{
        transform: "scale(1.1)"
    }
});

const UseCaseTradingBlock = ():JSX.Element => {
    
    const [anchorEl1, setAnchorEl1] = useState<null | HTMLAnchorElement | HTMLButtonElement>(null);
    
    useEffect(() => {
        initDiagramTradingBlock1();
    },[]);
    
    const handleAI = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>):void => {
        setAnchorEl1(e.currentTarget);
    };
    
    return <TradingBlockContainer>
        <TradingBlockTextContainer>
            <Tooltip title={"Asset: IQR, Direction: Finance and research in the field of AI"}>
                <TradingBlockTitle>
                    Asset: Insight Questor
                    <p>
                        Price exceeded price 100 $
                    </p>
                </TradingBlockTitle>
            </Tooltip>
        </TradingBlockTextContainer>
        <TradingBlockDiagram id={"TradingBlock"}/>
        <TradingBlockTopButtons>
            <TradingBlockTopButtonsContainer
                className={"sell/Buy"}
            >
                <Tooltip title={"Calculate the possible probabilities of the further course of events associated with a given financial asset using AI"}>
                    <TradingBlockTopButtonEl
                        onClick={handleAI}
                        sx={{
                            height: "36px"
                        }}>
                        <AIUseIcon color={"#FFFFFF"}/>
                    </TradingBlockTopButtonEl>
                </Tooltip>
            </TradingBlockTopButtonsContainer>
        </TradingBlockTopButtons>
        <Menu
            open={!!anchorEl1}
            anchorEl={anchorEl1}
            onClose={() => setAnchorEl1(null)}
            disableScrollLock={true}
        >
            <AIMenu articlesSettings={window.innerWidth >= 768 ? [6,10,14] : [2,3,5]}/>
        </Menu>
    </TradingBlockContainer>;
    
};

export default UseCaseTradingBlock;
